import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.css';
import Link from 'react-router-dom/Link';

const propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  to: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.string,
  iconPlacement: PropTypes.string,
}

const Icon = ({icon}) => <span className={classnames('material-icons', styles['button-icon'])}>{icon}</span>;

const Button = props => {
  const {type = 'button', label, buttonType, disabled, onClick, to, icon, iconPlacement = 'LEFT', style} = props;
  const button = (
    <button
      type={type}
      onClick={onClick}
      to={to}
      className={classnames(props.className, styles.button, styles[`${buttonType}-button`])}
      style={style}
      disabled={disabled}
    >
      {icon && iconPlacement.toUpperCase() !== 'RIGHT' && <Icon icon={icon} />}
      {(label || '').toUpperCase()}
      {icon && iconPlacement.toUpperCase() === 'RIGHT' && <Icon icon={icon} />}
    </button>
  );
  return to ? <Link to={to}>{button}</Link> : button;
};

Button.propTypes = propTypes;

export default Button;

/*
const Button = glamorous(ToolboxButton, {
  displayName: 'CustomButton',
  rootEl: 'button',
  forwardProps,
})(
  ({
    iconPosition = ICON_POSITION.LEFT,
    label,
    backgroundColor,
    color,
    disabled,
  }) => {
    let iconStyles = {};
    if (iconPosition === ICON_POSITION.RIGHT && label) {
      // move the icon to the right of the label if there is one
      iconStyles = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        '& span:first-child': {
          order: 3,
          marginRight: 0,
          marginLeft: '0.6rem',
        },
      };
    }

    let backgroundStyle = {};
    let textStyle = {};
    if (!disabled) {
      backgroundStyle = { backgroundColor: `${backgroundColor} !important` };
      textStyle = { color: `${color} !important` };
    }

    return {
      ...iconStyles,
      ...backgroundStyle,
      ...textStyle,
    };
  }
);

export default Button;
*/


// WEBPACK FOOTER //
// ./src/common/components/Button/index.js